import toLower from 'lodash/toLower'
import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useCurrentUser } from '@modules-deprecated/app/user'

import { QueryKeys } from '../../../enums/queryKeys'
import { Scope } from '../../../enums/scope'
import { isAuthorized } from '../../../utils/isAuthorized'
import { getSalaryConnectionStatus } from '../query-api'

const REGISTRATION_NUMBER_LENGTH = 8

export const useSalaryConnectionStatus = () => {
  const { organization, isLoading: isOrganizationLoading } = useUserOrganization()
  const { user, isLoading: isUserLoading } = useCurrentUser()
  const hasSalaryReadScope = isAuthorized(Scope.SalaryRead)

  const {
    data: connectionStatus,
    isLoading,
    ...rest
  } = useQuery(
    [QueryKeys.SalaryConnectionStatus, organization?.id, organization?.registrationNo],
    () =>
      getSalaryConnectionStatus(
        organization?.id as string,
        organization?.registrationNo as string,
        user?.email as string,
      ),
    {
      enabled:
        !!organization?.id &&
        !!organization.registrationNo &&
        organization.registrationNo.length === REGISTRATION_NUMBER_LENGTH &&
        !!user?.email &&
        hasSalaryReadScope,
    },
  )

  const countryId = organization?.countryId
  const { can_install: canInstall, is_connected: isConnected, can_connect: canConnect } = connectionStatus || {}

  const isSalaryAvailable = useMemo(() => {
    const isDanishOrganization = toLower(countryId) === 'dk'
    const hasSalaryIntegration = !!(canInstall || isConnected || canConnect)

    return !isLoading && hasSalaryIntegration && isDanishOrganization
  }, [isLoading, canConnect, canInstall, isConnected, countryId])

  return {
    ...rest,
    isLoading: isLoading || isOrganizationLoading || isUserLoading,
    isSalaryAvailable,
    isConnected,
    canInstall,
    canConnect,
  }
}
